module.exports = __webpack_public_path__ + "static/an-inconvenient-truth-c6c172b4cbe12009f8b70dd1b4b8f991.jpg";